import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

function ImageUpload({ onImageSelect, selectedType }) {
  const [selectedOption, setSelectedOption] = useState(selectedType);

  const onDrop = useCallback((acceptedFiles) => {
    if (!selectedOption) {
      alert('Please select Face & Hair or Body & Outfit first!');
      return;
    }
    
    const file = acceptedFiles[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File too large. Please upload an image under 5MB.');
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (e) => {
        onImageSelect(e.target.result, selectedOption);
      };
      reader.readAsDataURL(file);
    }
  }, [onImageSelect, selectedOption]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.webp']
    },
    multiple: false
  });

  const selectType = (type) => {
    setSelectedOption(type);
  };

  return (
    <div className="upload-section">
      {!selectedOption && (
        <div className="upload-type-selector">
          <div 
            className={`upload-type-card ${selectedOption === 'face' ? 'selected' : ''}`}
            onClick={() => selectType('face')}
          >
            <div className="type-icon">💇</div>
            <div className="type-title">Face & Hair</div>
            <div className="type-desc">Discover your face shape, skin tone, and get personalized hairstyle recommendations</div>
          </div>
          
          <div 
            className={`upload-type-card ${selectedOption === 'body' ? 'selected' : ''}`}
            onClick={() => selectType('body')}
          >
            <div className="type-icon">👔</div>
            <div className="type-title">Body & Outfit</div>
            <div className="type-desc">Analyze your body shape and get outfit recommendations for every occasion</div>
          </div>
        </div>
      )}

      {selectedOption && (
        <>
          <div 
            {...getRootProps()} 
            className={`dropzone ${isDragActive ? 'active' : ''}`}
          >
            <input {...getInputProps()} />
            
            {isDragActive ? (
              <p>Drop your photo here...</p>
            ) : (
              <>
                <div className="upload-icon">
                  {selectedOption === 'face' ? '📸' : '📷'}
                </div>
                <p><strong>Click to upload {selectedOption === 'face' ? 'selfie' : 'full body photo'}</strong></p>
                <p className="subtext">
                  {selectedOption === 'face' 
                    ? 'Front-facing, good lighting • Max 5MB' 
                    : 'Full body visible, standing straight • Max 5MB'}
                </p>
              </>
            )}
          </div>
          
          <button 
            onClick={() => setSelectedOption(null)} 
            className="btn-secondary"
            style={{marginTop: '20px'}}
          >
            ← Change Selection
          </button>
        </>
      )}
      
      {!selectedOption && (
        <div className="features">
          <div className="feature">✓ 100% Free</div>
          <div className="feature">✓ Private & Secure</div>
          <div className="feature">✓ Instant Results</div>
          <div className="feature">✓ Shop Recommended Products</div>
        </div>
      )}
    </div>
  );
}

export default ImageUpload;